<template>
	<core-page>
		<common-alerts :alerts="alerts"/>
		<core-loading class="integrations-loading" v-if="isLoading"/>
		<transition name="fade" mode="out-in">
			<div class="omapi-integrations" v-if="! isLoading">
				<!-- Existing Integrations -->
				<div v-if="showIntegrations" class="omapi-integrations__section">
					<h2>My Integrations</h2>
					<div id="om-my-integrations" class="omapi-integrations-wrap">
						<integrations-integration
							v-for="provider in integrations"
							v-bind:key="provider.slug"
							:provider="provider"
						/>
					</div>
				</div>
				<!-- Featured Integrations -->
				<div v-if="showFeatured" class="omapi-integrations__section">
					<h2>Featured Integrations</h2>
					<div id="om-featured-integrations" class="omapi-integrations-wrap">
						<integrations-integration
							v-for="provider in featuredProviders"
							v-bind:key="provider.slug"
							:provider="provider"
						/>
					</div>
				</div>
				<!-- All Integrations -->
				<div class="omapi-integrations__section all-integrations">
					<h2>All Integrations</h2>
					<integrations-filters/>
					<div id="om-all-integrations" class="omapi-integrations-wrap">
						<integrations-integration
							v-for="provider in providers"
							v-bind:key="provider.slug"
							:provider="provider"
						/>
					</div>
					<div v-if="showSearchAlert" class="search-alert">
						<integrations-partials-custom-integrations/>
					</div>
				</div>
			</div>
		</transition>
		<!-- Analytics Education Modal -->
		<integrations-modal-analytics />
		<!-- Custom Integrations Modal -->
		<integrations-modal-custom />
		<!-- Not Connected Modal -->
		<templates-modal-not-connected/>
	</core-page>
</template>

<script>
import { integration } from '@/integrations/mixins/integration'
import { createNamespacedHelpers } from 'vuex'
const { mapState } = createNamespacedHelpers('integrations')

export default  {
	mixins : [ integration ],
	created () {
		this.$store.dispatch('integrations/fetchIntegrationData').catch(() => {})

		// Fetch site settings here to get analytics accounts
		if (!this.$store.getters.isFetched('siteSettings')) {
			this.$store.dispatch('settings/fetchSiteSettings').catch(() => {})
		}
	},
	beforeDestroy () {
		this.resetProviders()
	},
	computed : {
		...mapState([
			'integrations',
			'providers',
			'featuredProviders',
			'filters',
			'search',
			'searchResults',
		]),
		/**
		 * Should Show Alert
		 *
		 * @since 2.4.0
		 *
		 * @returns {boolean} Are integrations loading?
		 */
		showSearchAlert () {
			return (this.isFiltering || this.isSearching) && 0 === this.searchResults.length
		},
		/**
		 * Is Loading
		 *
		 * @since 2.4.0
		 *
		 * @returns {boolean} Are integrations loading?
		 */
		isLoading () {
			return this.$store.getters.isLoading('integrations')
		},
		/**
		 * Alerts
		 *
		 * @since 2.4.0
		 *
		 * @returns {Array} An array containing the alerts.
		 */
		alerts () {
			return this.$get('$store.state.alerts', [])
		},
		/**
		 * Show Integrations
		 *
		 * @returns {boolean} Should we show the integrations section?
		 */
		showIntegrations () {
			return 0 < this.integrations.length
		},
		/**
		 * Show Featured Integrations
		 *
		 * @returns {boolean} Should we show the featured integrations section?
		 */
		showFeatured () {
			return 0 < this.featuredProviders.length
		},
	},
}
</script>

<style lang="scss">
	@import '../assets/scss/variables';
	@import '../assets/scss/pages/integrations';

	.omapi-app-integrations {
		.om-page {
			> .integrations-loading {
				position: absolute;
				display: flex;
				justify-content: center;
				align-items: center;
				width: 100%;
			}
		}
	}
	.search-alert {
		margin: auto;
		width: 879px;
	}
</style>
